import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Container,
  Image,
  Button,
  Breadcrumb,
} from "react-bootstrap";
import { useHistory } from "react-router";
import profile_pic from "../assets/images/profile_pic.png";
import edit_contact from "../assets/images/edit_contact.png";
import plus_toggle from "../assets/images/plus_toggle.png";
import { useSelector } from "react-redux";
import Select1 from "react-select";

import EditProfileModal from "../Components/EditProfileModal";
import { imageUrl, pdfUrl, URL, fallbackUser } from "../Config/apiUrl";
import { Get } from "../Axios/AxiosFunctions";
import BreadcrumbsB from "../Components/BreadcrumbsB";
import { color } from "@mui/system";
import { toast } from "react-toastify";
const CraftmanProfile = ({ setfooterStyle }) => {
  const history = useHistory();
  history.location.pathname ? setfooterStyle(true) : setfooterStyle(false);

  const [profileData, setProfileData] = useState(null);

  //   getProfileData
  const getProfileData = async () => {
    const params = new URLSearchParams(window.location.search);
    const id = params.get("id");

    if (!id) {
      toast.error("Something went wrong");
      return history.goBack();
    }
    const specificUser = URL(`general/craftman/profile/${id}`);
    const response = await Get(specificUser);
    if (response !== undefined) {
      setProfileData(response?.data?.data);
    } else {
      toast.error("Something went wrong");
      return history.goBack();
    }
  };

  useEffect(() => {
    getProfileData();
  }, []);

  return (
    <div className="craftman_profile">
      <Container className="small_container">
        {/* <div className="mt-5">
          <BreadcrumbsB currPageName={"Profile"} />
        </div> */}
        <div className="mt-5" />

        <Row>
          <Col className="profile_banner">
            <div className="profile_pic_div">
              <div className="profile_pic_innerdiv">
                <Image
                  className="profile_pic_innerdiv_img"
                  src={`${imageUrl}${profileData?.photo}`}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = fallbackUser;
                  }}
                />
              </div>
              <h3 className="whito font-30">{profileData?.userName}</h3>
            </div>
          </Col>
        </Row>
      </Container>
      <Container className="small_container">
        <Row className="margin-Profile">
          <Col lg={8} md={12}>
            <div className="col_eight_setting ">
              <h4 className="font-26">Summary</h4>

              <p>{profileData?.description}</p>
            </div>

            <div className="col_eight_setting mt-5">
              <div className="d-flex j-between a-center">
                <h4 className="font-26 mb-3">Skills</h4>
              </div>
              <div className="d-flex profile_page_tags">
                <div className="width_100">
                  <div className="d-flex mt-4 tags_sec">
                    {profileData?.skills?.map((item) => {
                      return <p> {item} </p>;
                    })}
                  </div>
                </div>
              </div>
              <div className="d-flex j-between mt-4 a-center">
                <h4 className="font-26 mb-3">Certificates</h4>
              </div>
              <div className="d-flex profile_page_tags">
                <div className="width_100">
                  <div className="d-flex mt-4 tags_sec">
                    {profileData?.certificates?.map((item) => {
                      return <p> {item}</p>;
                    })}
                  </div>
                </div>
              </div>
              <div className="d-flex j-between mt-4 a-center">
                <h4 className="font-26 mb-3">Education</h4>
              </div>
              <div className="mar-minus badar_battam">
                <div className="width_100">
                  <div className="d-flex mt-4">
                    {/* {profileData?.education?.map((item) => {
                      return <p> {item}</p>;
                    })} */}
                    {profileData?.education}
                    <br />
                    {profileData?.course}
                    <br />
                    {profileData?.school}
                  </div>
                </div>
              </div>
              <div className="d-flex j-between mt-4 a-center">
                <h4 className="font-26 mb-3">Experience</h4>
              </div>
              <div className="mar-minus ">
                <div className="width_100">
                  <div className="d-flex mt-4 tags_sec">
                    <p className="greenStyling">{profileData?.experience}</p>
                  </div>
                </div>
              </div>
            </div>
          </Col>

          <Col lg={4} md={12}>
            <Button
              style={{
                height: 50,
                width: "100%",
              }}
              onClick={() =>
                window.open(`${pdfUrl}${profileData?.cv}`, "_blank")
              }
            >
              Download CV
            </Button>

            <div className="details_div_main">
              <h4 className="font-26 mb-4">Contact Details</h4>
              <div className="contact_details_main mb-3">
                <div>
                  <p>Location</p>
                  <p className="p-20 black content">{profileData?.address}</p>
                </div>
              </div>
              <div className="contact_details_main mb-3">
                <div>
                  <p>Email Address</p>
                  <p className="p-20 black content">{profileData?.UserId?.email}</p>
                </div>
              </div>
              <div className="contact_details_main mb-3">
                <div>
                  <p>Phone Number</p>
                  <p className="p-20 black content">{profileData?.contactNo}</p>
                </div>
                <div></div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CraftmanProfile;
